import './App.css'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { RouterProvider } from 'react-router-dom'
import { loader as AuthWrapperPageLoader } from './components/pages/AuthWrapper'
import HomePage from './components/pages/Home'
import UserPortalPage from './components/pages/UserPortal'
import LoginPage from './components/pages/Login'
import SignUpPage from './components/pages/Signup'
import ForgetPasswordPage from './components/pages/ForgetPassword'
import AboutUsPage from './components/pages/AboutUs'
import ContactUsPage from './components/pages/ContactUs'
import HoldingsPage from './components/pages/Holdings'
import ProjectsPage from './components/pages/Projects'
import ListingPage from './components/pages/MyBids'
import RetirementsPage from './components/pages/Retirements'
import RootPage from './components/pages/Root'
import PasswordResetPage from './components/pages/PasswordReset'
import Kyc from './components/pages/Kyc'
import ProjectDetails from './components/organisms/PDP'
import IndexPage from './components/pages'
import ProjectUpload from './components/pages/ProjectUpload'
import BidPage from './components/pages/Bid'
import AllCarbonCreditPage from './components/pages/AllCarbonCredit'
import SeeAllUsers from './components/pages/SeeAllUsers'
import RequestPage from './components/pages/Request'
import Wishlist from './components/pages/Wishlist'
import WalletPage from './components/pages/Wallet'
import ProfilePage from './components/pages/MyProfile'
import ProfileDescription from './components/pages/ProfileDescription'
import HistoryPage from './components/pages/History'
import NewsDescription from './components/pages/NewsDescription'
import OrderSummary from './components/pages/OrderSummary'
import { useSelector } from 'react-redux'
import AuthWrapper from './components/pages/AuthWrapper'
import ErrorPage from './components/pages/Error'
import Report from './components/pages/Report'
import ProtectedRoute from './utils/ProtectedRoute'
import TestingPage from './components/pages/Test'
import KycSignaturePopup from './components/atoms/KycSignaturePopup'
import TermsPage from './components/pages/Terms'
import PrivacyPage from './components/pages/Privacy'
import OGScorePage from './components/pages/OGScore'
import SignIn from './components/pages/SignIn'
import ResetPasswordTest from './components/pages/Test'
import { SessionLogin } from './components/pages/SessionLogin'
import FaqPage from './components/pages/Faq'
function App () {
  const { userType } = useSelector(state => state.authReducer)
  return (
    <main className='font-spaceGrotesk max-w-screen-2xl mx-auto'>
      <RouterProvider
        router={createBrowserRouter([
          {
            path: '/',
            element: <IndexPage />,
            children: [
              {
                path: '/',
                element: <RootPage />,
                children: [
                  { index: true, element: <HomePage /> },
                  // { path: "about-us", element: <AboutUsPage /> },

                  {
                    path: 'projects',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['seller']}>
                        <ProjectsPage />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'project/:id',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <ProjectUpload />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'holdings',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <HoldingsPage />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'my-bids',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <ListingPage />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'retirements',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['buyer']}>
                        <RetirementsPage />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'requests',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['buyer', 'trader']}>
                        <RequestPage />
                      </ProtectedRoute>
                    )
                  },

                  {
                    path: 'news-description/:id',
                    element: <NewsDescription />
                  },
                  { path: 'bid', element: <BidPage /> },
                  {
                    path: 'project-details',
                    element: <ProjectDetails />
                  },
                  {
                    path: 'kyc',
                    element: !userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <Kyc />
                      </ProtectedRoute>
                    )
                  },

                  {
                    path: 'profile',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProfilePage />
                    )
                  },
                  {
                    path: 'upload-project',
                    element: !userType ? (
                      <Navigate to='/user-portal' />
                    ) : (
                      <ProtectedRoute access={['seller']}>
                        <ProjectUpload />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'all-carbon-credit',
                    element: <AllCarbonCreditPage />
                  },
                  { path: 'all-users', element: <SeeAllUsers /> },
                  {
                    path: 'wishlist',
                    element: !userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <Wishlist />
                      </ProtectedRoute>
                    )
                  },

                  {
                    path: 'wallet',
                    element: !userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <WalletPage />
                      </ProtectedRoute>
                    )
                  },
                  {
                    path: 'profile-description/:_id',
                    element: <ProfileDescription />
                  },
                  {
                    path: 'history',
                    element: !userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <HistoryPage />
                      </ProtectedRoute>
                    )
                  },

                  {
                    path: 'order-summary',
                    element: !userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <OrderSummary />
                      </ProtectedRoute>
                    )
                  },

                  {
                    path: 'report',
                    element: !userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ProtectedRoute access={['seller', 'buyer', 'trader']}>
                        <Report />
                      </ProtectedRoute>
                    )
                  }
                ]
              },
              {
                path: '/user-portal',
                element: userType ? <Navigate to='/' /> : <UserPortalPage />
              },
              {
                path: '/:userType',
                element: <AuthWrapper />,
                loader: AuthWrapperPageLoader,
                children: [
                  {
                    index: true,
                    element: userType ? <Navigate to='/' /> : <LoginPage />
                  },
                  {
                    path: 'forgot-password',
                    element: userType ? (
                      <Navigate to='/' />
                    ) : (
                      <ForgetPasswordPage />
                    )
                  },
                  {
                    path: 'sign-up',
                    element: userType ? <Navigate to='/' /> : <SignUpPage />
                  }
                ]
              },

              {
                path: '/session/:token',
                element: <SignIn />
              },
              {
                path: '/switch/:token',
                element: <SessionLogin />
              },
              {
                path: '/passwordReset',
                element: <PasswordResetPage />
              },
              { path: 'about-us', element: <AboutUsPage /> },
              { path: '/contact-us', element: <ContactUsPage /> },

              { path: '/og-score', element: <OGScorePage /> },
              { path: 'terms', element: <TermsPage /> },
              { path: 'faq', element: <FaqPage /> },

              
              { path: 'privacy', element: <PrivacyPage /> },
              {
                path: '*',
                element: <ErrorPage status={400} />
              },
              {
                path: '/test',
                // element: <TestingPage />,
                element: <ResetPasswordTest />
                // element: <KycSignaturePopup />,
              }
            ]
          }
        ])}
      />
      <Toaster />
    </main>
  )
}

export default App
